<template>
  <div class="bg-container page">
    <img src="img/login/login-bg.png" class="bg-img">
    <div class="bg-wrapper">
      <div class="login">
        <div class="nav-bar van-nav-bar van-hairline--bottom">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left"   @click="back()">
              <i class="van-icon van-icon-arrow-left" style="color: rgb(255, 255, 255);"> </i>
            </div>
            <div class="van-nav-bar__title van-ellipsis"></div>
            <div class="van-nav-bar__right" @click="toLang()">
              <div class="language">{{ nameLangs() }} </div>
            </div>
          </div>
        </div>
        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img :src="this.$store.getters.getBaseInfo.login_ico !==undefined ?this.$store.getters.getBaseInfo.login_ico:'/img/null.png'" class="logo-img">
            </div>
          </div>
          <div class="loginForm">
            <div class="input van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body">
                  <input :placeholder="$t('login.username')"  v-model="username" type="text"  class="van-field__control van-field__control--center">
                </div>
              </div>
            </div>
            <div class="input van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body">
                  <input :placeholder="$t('login.password')" v-model="password" :type="passwordType" class="van-field__control van-field__control--center">
                  <van-icon :name="passwordType === 'password' ? 'closed-eye':'eye-o'" style="font-size: 20px;color: rgb(194, 68, 145);" @click="switchPasswordType"/>
                </div>
              </div>
            </div>
            <div class="register-text" style="margin-top: 20px;">
              <span @click="toRegister">{{ $t("login.registerNow") }}</span>
            </div>
            <button class="login-btn van-button van-button--primary van-button--normal" @click="doLogin()">
              <div class="van-button__content"><span class="van-button__text">{{ $t("login.doLogin") }}</span></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import langList from "../../locale/langList";
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lang: "",
      username: '',
      password: this.inputValue,
      passwordType: 'password',
      list: langList
    };
  },
  methods: {
    nameLangs() {
      return this.list[this.lang];
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      this.$router.push("/")
    },
    toLang() {
      this.$router.push({path: '/SetLang'});
    },
    toRegister() {
      this.$router.push("Register")
    },
    doLogin() {
      if (this.username === "" || this.username === null || this.username === undefined) {
        this.$toast(this.$t('login.username') + "!");
        return false;
      }
      if (this.password === "" || this.password === null || this.password === undefined) {
        this.$toast(this.$t('login.password') + "!");
        return false;
      }
      this.$http({
        method: 'get',
        data: {username: this.username, password: this.password},
        url: 'member_login'
      }).then(res => {
        console.log(res);
        if (res.code === 200) {
          console.log(res.data.id);
          this.$toast.success(this.$t("msg." + res.msg));
          localStorage.setItem('token', res.data.id)
          this.$router.push("Mine")
        } else {
          this.$toast(this.$t("msg." + res.msg));
        }
      })
    }
  },
  created() {
    this.lang = localStorage.getItem('lang');
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

</style>
